import React from 'react';
import { Tooltip } from 'antd';
// import { createLanguageFilters } from '@utils/supportedLanguages';
// import LanguageIcon from '@components/LanguageIcon';
import PublishedStatusIcon from '@components/PublishedStatusIcon';
import { NOTIFICATION_ONLY, OPEN_CONTENT, OPEN_LINK } from '@constants';
import './style.less';

export default (t, defaultFilteredValue, contentTypeTranslationKey) => [
  // {
  //   title: t('cards:MessagesList.columns.language.title'),
  //   dataIndex: 'language',
  //   defaultFilteredValue: defaultFilteredValue.language || [],
  //   key: 'language',
  //   render: language => <LanguageIcon language={language} />,
  //   width: 150,
  //   sorter: (a, b) => a.language > b.language,
  //   filters: createLanguageFilters(t),
  //   onFilter: (value, record) => record.language === value,
  // },
  {
    title: t(`cards:MessagesList.columns.${contentTypeTranslationKey}.title`),
    dataIndex: 'name',
    key: 'name',
    width: 220,
    ellipsis: true,
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: t(`cards:MessagesList.columns.description`),
    key: 'description',
    width: 220,
    ellipsis: true,
    render: message => message?.latestVersion?.body || '',
  },
  {
    title: t(`cards:MessagesList.columns.actionType.title`),
    dataIndex: 'uuid',
    key: 'uuid',
    defaultFilteredValue: defaultFilteredValue.actionType || [],
    width: 150,
    render: (uuid, record) => {
      const actionType = record?.latestVersion?.payload?.action || record?.payload?.action;
      return t(`cards:MessagesList.columns.actionType.${actionType}`);
    },
    filters: [
      {
        text: t(`cards:MessagesList.columns.actionType.${NOTIFICATION_ONLY}`),
        value: NOTIFICATION_ONLY,
      },
      {
        text: t(`cards:MessagesList.columns.actionType.${OPEN_CONTENT}`),
        value: OPEN_CONTENT,
      },
      {
        text: t(`cards:MessagesList.columns.actionType.${OPEN_LINK}`),
        value: OPEN_LINK,
      },
    ],
    onFilter: (value, record) => {
      const actionType = record?.latestVersion?.payload?.action || record?.payload?.action;
      return value === actionType;
    },
  },
  {
    title: t(`cards:MessagesList.columns.content.title`),
    dataIndex: 'url',
    key: 'url',
    width: 200,
    render: (url, record) => {
      const content =
        record?.latestVersion?.payload?.data?.name ||
        record?.payload?.data?.name ||
        record?.latestVersion?.payload?.data ||
        record?.payload?.data;
      return content;
    },
  },
  {
    title: t('cards:MessagesList.columns.published.title'),
    dataIndex: 'published',
    defaultFilteredValue: defaultFilteredValue.published || [],
    key: 'published',
    className: 'published-column',
    render: published => (
      <Tooltip
        placement="bottom"
        title={
          published
            ? t('cards:MessagesList.columns.published.published')
            : t('cards:MessagesList.columns.published.unpublished')
        }
      >
        <PublishedStatusIcon published={published} />
      </Tooltip>
    ),
    width: 150,
    filters: [
      {
        text: t('cards:MessagesList.columns.published.published'),
        value: true,
      },
      {
        text: t('cards:MessagesList.columns.published.unpublished'),
        value: false,
      },
    ],
    onFilter: (value, record) => record.published === value,
  },
];
